import cn from "classnames";
import moment from "moment";
import React, {useEffect} from "react";
import {useForm} from "react-hook-form";
import {COUNTRY} from "../../constant";
import DatePicker from "../common/DatePicker";

const MIN_DATE = moment().subtract("M", 6).valueOf();
const MAX_DATE = moment().add("M", 6).valueOf();

function ConfigurationForm({ isLoading, submit, isSubmitting }) {
  const {
    register,
    handleSubmit,
    getValues,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      countryCode: "95",
    },
  });

  useEffect(() => {
    if (!isSubmitting) {
      setValue("amount", undefined);
      setValue("date", undefined);
      setValue("countryCode", "95");
    }
  }, [isSubmitting]);

  function onSubmit(values) {
    submit(values);
  }

  function validateRate(value) {
    if (!new RegExp(/^[+-]?\d{1,4}\.\d{1,8}$/).test(value)) {
      return "Integer not more than 4 digits and decimal not more than 8 digits";
    }
    if (parseFloat(value) <= 0) {
      return "Must greater than 0";
    }
    return true;
  }

  return (
    <form
      className="form"
      onSubmit={handleSubmit(onSubmit)}
      autoComplete="off"
      data-testid="configuration-form"
    >
      <div className="p-4">
        <div className="row">
          <div className="offset-md-3 col-sm-5">
            <div className="form-group row">
              <label className="col-form-label col-sm-5 text-lg-right" htmlFor={"country-code"}>
                Country
              </label>
              <div className="col-sm-7 p-0">
                <select data-testid="country-code"
                  className="form-control"
                  {...register("countryCode", { required: true })}
                >
                  {COUNTRY.map((x) => (
                    <option key={x.code} value={x.code}>
                      {x.name} ({x.currency})
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-form-label col-sm-5 text-lg-right">
                Transaction Date
              </label>
              <div className="col-sm-7 p-0">
                <DatePicker
                  control={control}
                  name="date"
                  minDate={MIN_DATE}
                  maxDate={MAX_DATE}
                  date={getValues("date")}
                  errors={errors}
                  rules={{
                    required: {
                      value: true,
                      message: "Please input date",
                    },
                  }}
                />
                {errors?.date && (
                  <span className="input-error-message">
                    {errors?.date?.message}
                  </span>
                )}
              </div>
            </div>
            <div
              className={cn("form-group row mb-4", {
                "form-group-error": errors?.amount,
              })}
            >
              <label className="col-form-label col-sm-5 text-lg-right" htmlFor={"amount"}>
                Bank Cost Rate
              </label>
              <div className="col-sm-7 p-0">
                <input data-testid="amount"
                  className="form-control"
                  {...register("amount", {
                    required: {
                      value: true,
                      message: `Please input rate`,
                    },
                    validate: (value) => validateRate(value),
                  })}
                />
                {errors?.amount && (
                  <span className="input-error-message">
                    {errors?.amount?.message}
                  </span>
                )}
              </div>
            </div>
            <div className="form-group row">
              <div className="offset-sm-5 col-sm-7 p-0">
                <button className="btn btn-warning" disabled={isLoading || isSubmitting} >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}

export default ConfigurationForm;
